// extracted by mini-css-extract-plugin
export default {"card":"TrendingTrees_card__Lweor","cover":"TrendingTrees_cover__Wiz7z","body":"TrendingTrees_body__jtQb7","title":"TrendingTrees_title__Otz46","meta":"TrendingTrees_meta__Wd-CK"};